// extracted by mini-css-extract-plugin
module.exports = {"stepbar":"FormRegistrazione_stepbar__d0CES","condizioniPrivacyTitle":"FormRegistrazione_condizioniPrivacyTitle__Hu_FN","rotation":"FormRegistrazione_rotation__XlrGG"};